import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

/* Function */
import ObjGeneral from '../function/';
/* Local store */
import { localStoreFN } from '../../store/localStorage';

/* Actions */
import * as summaryFatigueActions from '../../actions/summary_fatigue/index';
import * as detailFatigueActions from '../../actions/detail_fatigue/index';
import * as tagsActions from '../../actions/common/tags/index';

/* Components */
import { Tooltip } from 'react-bootstrap';
import Header from '../../components/summary_fatigue/header';
import TitleMain from '../../components/summary_fatigue/titleMain';
import SummaryMain from '../../components/summary_fatigue/summaryMain';
import SummaryTable from '../../components/summary_fatigue/summaryTable';
import Loading from '../../components/common/loading';
import Message from '../../components/common/message';
import Expired from '../expired/index';

class SummaryFatigue extends Component {
  constructor(props) {
    super(props);
    this.state = {
      select: ''
    };
  }

  async componentDidMount() {
    const permits = localStoreFN().getItem('permits');
    const permit = permits.includes('fatigue');
    if (permit) {
      if (this.props.setting) {
        const obj = JSON.parse(this.props.setting.value);
        if (obj.generalSetting.views.includes('fatigue')) {
          let main;
          if (obj.summaryFatigue) {
            main = obj.summaryFatigue.main ? obj.summaryFatigue.main : obj.generalSetting.main;
          } else {
            main = obj.generalSetting.main;
          }
          const dateStart = this.props.filters.date.fechaStartFinal || null;
          const dateEnd = this.props.filters.date.fechaEndFinal || null;
          const tags = this.props.filters.tags;
          const mainPers = this.props.filters.main || main;

          await this.props.actions.fetchSummaryFatigueApi({
            main: mainPers,
            dateStart,
            dateEnd,
            tags
          });
          this.setState({ select: mainPers });
        } else {
          this.props.history.push('/dashboard/authorization');
        }
      }
    } else {
      // not authorized
      this.props.history.push('/dashboard/authorization');
    }
  }

  componentWillUnmount() {
    this.props.actions.resetSummaryFatigue();
  }

  handleSubmit = async obj => {
    /* GROUP */
    const group = document.getElementById('group').value;
    const format = this.props.language.account.date.format;
    this.setState({ select: group });
    /* TAGS */
    const tags = (obj.multipleTagsInputIsMultiple) ? ObjGeneral.getTags(obj) : this.props.filters.tags;
    /* DATE */
    const date = ObjGeneral.getDate(obj, format);

    this.props.actions.setFilterSummaryFatigue({
      tags: tags,
      date: date,
      main: group
    });

    await this.props.actions.fetchSummaryFatigueApi({
      main: group,
      tags: tags,
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal
    });
  };

  link = event => {
    const objLink = JSON.parse(this.props.setting.value);
    const settingLink = ObjGeneral.getSetting({
      setting: objLink.summaryFatigue,
      filter: this.props.filter,
      general: objLink.generalSetting
    });
    const format = this.props.language.account.date.format;
    const date = ObjGeneral.getDate({ id: null }, format);

    let tags = [];
    if (event.currentTarget.dataset.datos) {
      const objDatosLink = JSON.parse(event.currentTarget.dataset.datos);
      settingLink.filter.forEach(item => {
        if (item.name === this.state.select) {
          tags.push(objDatosLink.tag);
        }
      });
    } else {
      tags = this.props.filters.tags;
    }
    document.getElementById('menu-1-sub-1').classList.remove('active');
    document.getElementById('menu-1-sub-2').classList.add('active');
    this.props.detailActions.setFilterDetailFatigue({
      tags: tags,
      date: date
    });
    this.props.history.push('/dashboard/detail_fatigue');
  };

  render() {
    if (this.props.setting) {
      const obj = JSON.parse(this.props.setting.value);
      const setting = ObjGeneral.getSetting({
        setting: obj.summaryFatigue,
        filter: this.props.filter,
        general: obj.generalSetting
      });
      const { graphColorRange } = obj;
      const language = this.props.language ? this.props.language.filter : '';
      return (
        <section className="main">
          <Header
            loadingFilter={this.props.loadingFilter}
            filters={this.props.filters}
            filter={setting.filter}
            language={language}
            date={this.props.dateMax[0]}
            group={setting.group}
            handleSubmit={this.handleSubmit}
            select={this.state.select}
          />
          {this.props.loading ? (
            <Loading language={this.props.language} />
          ) : this.props.status === 401 || this.props.statusTags === 401 ? (
            <Expired
              history={this.props.history}
              language={this.props.language ? this.props.language : ''}
            />
          ) : this.props.status === 200 && this.props.statusTags === 200 ? (
            <div className="main-container">
              <TitleMain
                categorizationSeverity={this.props.datos.severity}
                borderLeft={true}
                title={
                  this.state.select
                    ? `${this.props.language.summary.fatigue.biocompatibilityEvolution} ${this.props.language.summary.title.general[this.state.select.toLowerCase()]}`
                    : ''
                }
                border={this.border}
              />
              <Tooltip placement="top" id="pageTooltip" />
              <SummaryMain
                date={this.props.dateMax[0]}
                filters={this.props.filters}
                title={this.props.language}
                graphColorRange={graphColorRange}
                link={this.link}
                categorizationSeverity={this.props.datos.severity}
                dailyFatigueEvolution={this.props.datos.fatigueRiskPercentageEvolutions}
                fatigueDistribution={this.props.datos.fatigueRiskDistributions}
                language={this.props.language}
              />
              <TitleMain
                className="top topx1-5"
                title={
                  this.state.select
                    ? this.props.language.summary.title[this.state.select.toLowerCase()]
                    : ''
                }
              />
              <SummaryTable
                language={this.props.language}
                link={this.link}
                main={this.state.select}
                graphColorRange={graphColorRange}
                indicatorsByCategorization={this.props.datos.indicatorByTagList}
                table={
                  this.state.select
                    ? this.props.language.filter[this.state.select.toLowerCase()]
                    : ''
                }
              />
            </div>
          ) : this.props.status === 500 || this.props.statusTags === 500 ? (
            <Message message={this.props.language.error.apiError500} />
          ) : (
            <Message message={this.props.language.error.apiError} />
          )}
        </section>
      );
    } else {
      return (
        <section className="main">
          <Message message="NO Setting" />
        </section>
      );
    }
  }
}

const mapStateToProps = state => ({
  filter: state.reducer.tags.filter,
  statusTags: state.reducer.tags.status,
  loadingFilter: state.reducer.tags.loading,

  dateMax: state.reducer.dashboard.dateMax,
  setting: state.reducer.dashboard.setting,
  language: state.reducer.dashboard.language,
  datos: state.reducer.summaryFatigue.datos,
  loading: state.reducer.summaryFatigue.loading,
  status: state.reducer.summaryFatigue.status,
  filters: state.reducer.summaryFatigue.filters
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(summaryFatigueActions, dispatch),
  detailActions: bindActionCreators(detailFatigueActions, dispatch),
  tagsActions: bindActionCreators(tagsActions, dispatch)
});

SummaryFatigue.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SummaryFatigue);



// WEBPACK FOOTER //
// ./source/client/containers/summary_fatigue/index.jsx